<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Profissional responsável"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.usuarioNome"
                                label="Profissional"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.unidadeNomeFantasia"
                                label="Unidade"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.infraestruturaNome"
                                label="Local de atendimento"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.codigoEquipe"
                                label="Código da equipe"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.ocupacaoDescricao"
                                label="Ocupação"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.data"
                                label="Data"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Atendimento"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="3">
                            <Item
                                :get-value="() => item.turnoNome"
                                label="Turno"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                :get-value="() => item.imovelTipoDescricao"
                                label="Tipo de imóvel"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                :get-value="() => item.latitude"
                                label="Latitude"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                :get-value="() => item.longitude"
                                label="Longitude"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.visitaCompartilhada"
                                label="Visita compartilhada com outro profissional"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Motivo da visita"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-area
                                title="Tipo de visita"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.motivosVisita.tipoVisita.join(', ')"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-area
                                title="Busca ativa"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.motivosVisita.buscaAtiva.join(', ')"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-area
                                title="Controle ambiental/vetorial"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.motivosVisita.controleAmbientalVetorial.join(', ')"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-area
                                title="Acompanhamento"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.motivosVisita.acompanhamento.join(', ')"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-area
                                title="Outros"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="12">
                                        <Item
                                            :get-value="() => item.motivosVisita.outrosMotivos.join(', ')"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-area
                    title="Avaliação antropométrica"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.peso"
                                label="Peso (kg)"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.altura"
                                label="Altura (cm)"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-area
                    title="Sinais vitais"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.afericaoPa"
                                label="Aferição de PA"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.temperatura"
                                label="Temperatura (ºC)"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-area
                    title="Glicemia"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.glicemia"
                                label="Glicemia"
                            />
                        </rkm-col>

                        <rkm-col cols="6">
                            <Item
                                :get-value="() => item.glicemiaMomentoColeta"
                                label="Momento da coleta"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Desfecho"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.desfechoDescricao"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Complemento"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.complemento"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>